import React from 'react';
import { Grid } from 'semantic-ui-react';
import { isMultiOperatorApplicationType } from 'services/sprayEvents/utils';

interface Props {
    applicationType: string;
}

export default function ProductApplicationPerOperatorLabel(
    props: Props
): React.ReactElement | null {
    const { applicationType } = props;

    if (isMultiOperatorApplicationType(applicationType)) {
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width="8">
                        <h4>Product application per operator</h4>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    return null;
}
